import React, { useState, useContext } from "react";
import styled from "styled-components";
import { TitleText } from "../../ui/Text";
import { ToggleButton } from "../../ui/ToggleButton";
import { ScorecardIcon } from "../../assets/svg/ScorecardIcon";
import { CircleIcon } from "../../assets/svg/CircleIcon";
import { Route,useLocation } from "react-router-dom";
import SummaryView from "./SummaryView/SummaryView";
import DataView from "./DataView/DataView";
import { SCORECARD_URL } from "../../api/urls";
import { GetHook } from "../../api/api";
import { get } from "../../utils/get";
import Modal from "../../ui/Modal";
import { UpdateMeasures } from "../dashboard/UpdateMeasures";
import { Button } from "../../ui/Button";
import { Modal360 } from "./Modal360";
import { AuthContext } from "../../context/AuthContext";
import moment from "moment";
import { DateContext } from "../../context/DateFilterContext";
import DropdownButton from '../../ui/DropDownButton';
import Axios from '../../utils/axios';
import { toast } from 'react-toastify';
import CustomTabs from "../../ui/CustomTabs";
import MeasuresTab from "./MeasuresTab";
import { title } from "process";
import useAuth from "../../hooks/useAuth";

interface ScorecardProps {
  path?: string;
  selectedScorecard?: any[];
  setDateFilter?: any;
  dateFilter?: any;
}

const ScorecardView = ({
  path,
  selectedScorecard,
  setDateFilter,
  dateFilter,
}: ScorecardProps) => {
  const [isUpdateMeasuresModal, setUpdateMeasuresModal] = useState(false);
  const [modal360Open, setModal360Open] = useState(false);
  const auth = useAuth();
  const { isAdmin, isManager, authState } = auth;
  const location = useLocation();
  // const [dateFilterState, setDateFilterState] = useContext(DateContext)
  

  const date =
    get(dateFilter, "startDate") && get(dateFilter, "endDate")
      ? `interval=${moment(get(dateFilter, "startDate")).format(
          "YYYY-MM-DD"
        )}/${moment(get(dateFilter, "endDate")).format("YYYY-MM-DD")}`
      : "";

  const { user } = get(auth, "authState");
  let { data: perspectivesData } = GetHook(
    selectedScorecard && selectedScorecard.length > 0 && date
      ? `${SCORECARD_URL}/${get(
          selectedScorecard[0],
          "id",
          ""
        )}/perspective?${date}`
      : "null"
  );

  let { data: objectivesData } = GetHook(
    selectedScorecard && selectedScorecard.length > 0 && date
      ? `${SCORECARD_URL}/${get(
          selectedScorecard[0],
          "id",
          ""
        )}/objective?${date}`
      : "null"
  );

  //removed interval

  let { data: kpisData } = GetHook(
    selectedScorecard && selectedScorecard.length > 0 && date
      ? `${SCORECARD_URL}/${get(selectedScorecard[0], "id", "")}/kpi`
      : "null"
  );
  const indicatorData = perspectivesData.map((per) => {
    return {
      name: get(per, "perspective_name"),
      weight: get(per, "weight"),
      score: get(per, "periodic_score"),
      weighted_score: get(per, "weighted_periodic_score"),
    };
  });
   //@ts-ignore
   let sum = indicatorData.reduce(function(prev, current) {
    //@ts-ignore
    return prev + +current?.score/indicatorData?.length
  }, 0).toFixed(2);
  
  const summaryData = {
    name: get(selectedScorecard, "[0]display_name", "-"),
    target: get(selectedScorecard, "[0]target"),
    weight: get(selectedScorecard, "[0]weight"),
    maxScore: get(selectedScorecard, "[0]max_score"),
    minScore: get(selectedScorecard, "[0]min_score"),
    baseLine: get(selectedScorecard, "[0]baseline"),
    score: get(selectedScorecard, "[0]periodic_score"),
    weighted_score: get(selectedScorecard, "[0]weighted_periodic_score"),
    optimization: get(selectedScorecard, "[0]optimisation"),
    type: get(selectedScorecard, "[0]perspective.perspective_type"),
    scoreType: get(selectedScorecard, "[0]perspective.score_type"),
    operatingScore: get(selectedScorecard, "[0]weighted_periodic_score"),
    comments: get(selectedScorecard, "[0]comments", []),
    // variance: get(selectedScorecard, "[0]periodic_variance", []),
    status: get(selectedScorecard, "[0]status", []),
  };


  const handleApprove = () => {
    Axios.put(`${SCORECARD_URL}/${get(
      selectedScorecard&&selectedScorecard[0],
      "id",
      ""
    )}`, { status: 'active' }).then(res => {
      toast.success('Scorecard approved');
      
      console.log(res.data.returned_resultset);
    });
  };

  const handleArchive = () => {
    Axios.put(`${SCORECARD_URL}/${get(
      selectedScorecard&&selectedScorecard[0],
      "id",
      ""
    )}`, { status: 'archived' }).then(res => {
      toast.success('Scorecard archived');
      
    });
  };

  const handleReject = () => {
    Axios.put(`${SCORECARD_URL}/${get(
      selectedScorecard&&selectedScorecard[0],
      "id",
      ""
    )}`, { status: 'draft' }).then(res => {
      toast.success('Scorecard rejected');
      
    });
  };

  const handleRequest = () => {
    Axios.put(`${SCORECARD_URL}/${get(
      selectedScorecard&&selectedScorecard[0],
      "id",
      ""
    )}`, { status: 'pending-approval' }).then(
      res => {
        toast.success('Approval request sent');
        
      }
    );
  };

  const userId = get(user, "id");

  const tabs = [
    { title: 'All Measures', content: <UpdateMeasures scorecard_id={selectedScorecard && get(selectedScorecard[0], "id", "")}/>},
    { title: 'Approved Measures', content: <MeasuresTab user_id={userId} status="approved" scorecard_id={selectedScorecard && get(selectedScorecard[0], "id", "")} /> },
    { title: 'Rejected Measures', content: <MeasuresTab user_id={userId} status="rejected" scorecard_id={selectedScorecard && get(selectedScorecard[0], "id", "")}/> },
    { title: 'Pending-Approval Measures', content: <MeasuresTab user_id={userId} status="pending-approval" scorecard_id={selectedScorecard && get(selectedScorecard[0], "id", "")} /> }
  ];

  return (
    <>
      <ScorecardViewContainer>
        <Header>
          <TitleText>
          <span style={{ fontSize: 14, color: "#214160", opacity: 0.5 , marginBottom: 10}}>
          {summaryData?.name}
          <CardLabel
          color={
            get(summaryData, "status", "") === "active" ? "#0eab64" :  "#222222"
          }
          backgroundColor={
            get(summaryData, "status", "") === "active" ? "#b7f7e6" :  "#c4c4c4"
          }
          style={{ marginLeft: 10 }} 
          disabled ={true}
          >
          <TitleText
          style={{ fontSize: 15 , paddingLeft: 12 , paddingRight: 12}} 
          
          >
          {summaryData?.status}
          </TitleText>
          </CardLabel>
          
          </span>
            Scorecard Overview         

            </TitleText>
            
          <span>

          <div
          style={{
            display: 'inblock',
            gridTemplateColumns: '1fr 1fr',
            columnGap: '1em',
            paddingBottom: '1em',
            height: '1em',
            position: 'relative'
          }}
        >
         
        
        </div>

          &nbsp;

        
            <Button
              text="360º"
              backgroundColor="#fff"
              color="#D51067"
              style={{
                borderColor: "#f06d9b",
                borderWidth: "2px",
                borderStyle: "solid",
                marginRight: "1em",
                padding: "0 2em",
              }}
              onClick={() => setModal360Open(true)}
            />
            <ToggleButton
              url2="data"
              url1="summary"
              ButtonData2={{ label: "Data", icon: ScorecardIcon }}
              ButtonData1={{ label: "Summary", icon: CircleIcon }}
            />
            {get(selectedScorecard, "[0]owner_id") === get(user, "id")&& get(selectedScorecard, "[0]status")!== "archived"? (
              <Button
                text="Manage measures"
                onClick={() => setUpdateMeasuresModal(true)}
              />
            ) : null}
          </span>
        </Header>
        <>
          <Route
          exact
            path={`${path}/summary`}
            render={() => (
              <SummaryView
                title="Scorecard"
                selectedScorecard={selectedScorecard}
                data={summaryData}
                indicatorTitle="Perspectives"
                indicatorData={indicatorData}
                dateFilter={dateFilter}
                setDateFilter={setDateFilter}
              />
            )}
          />
          <Route
          exact
            path={`${path}/data`}
            render={() => (
              <DataView
                title="Scorecard"
                data={kpisData}
                name={summaryData?.name}
                setDateFilter={setDateFilter}
                perspectives={perspectivesData}
                objectives={objectivesData}
              />
            )}
          />
        </>
      </ScorecardViewContainer>
      {isUpdateMeasuresModal && (
        <Modal
          width="90%"
          closeModal={() => setUpdateMeasuresModal(false)}
          title=""
          handleSubmit={() => null}
          noFooter
        >
          <TitleText>
            Manage measures
            <span style={{ fontSize: 14, color: "#214160", opacity: 0.5 }}>
              - {summaryData?.name}
            </span>
          </TitleText>
          <br/>
          <CustomTabs tabs={tabs} />
        </Modal>
      )}

      {modal360Open && (
        <Modal
          width="80%"
          height="65vh"
          overflow="scroll"
          closeModal={() => setModal360Open(false)}
          title=""
          handleSubmit={() => null}
          noFooter
        >
          <Modal360 closeModal={() => setModal360Open(false)} />
        </Modal>
      )}
    </>
  );
};

export default ScorecardView;

const ScorecardViewContainer = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
  padding: 3.3em 1em;
  span {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const CardLabel = styled.button<{
  backgroundColor: string;
  color: string;
}>`
border-radius: 0.5em;
box-shadow: none;
display: grid;
align-items: center;
background-color: ${(props) => props.backgroundColor};
border-color: ${(props) => props.color};
border-style: solid
${TitleText} {
  color: ${(props) => props.color};
  text-align: center;
  font-size: 12px;
  text-transform: capitalize;
}
`;

const LabelButton = styled(Button)`
  /* width: 50%; */
`;